const API = {
  // 1.创建账号
  CreateAccount: "api/post/createAccount",

  // 2.进入游戏
  LoginGame: "api/post/forwardGame",
  
  // 3.用戶充值
  PayAccount: "api/post/payAccount",
};
export default API;
